import React from 'react';
import { X, Check } from 'lucide-react';
const comparisons = [{
  before: 'Tworzysz nowy plan lekcji co tydzień od zera',
  after: 'Masz gotowe plany na 40 pełnych tygodni — gotowe do użycia natychmiast'
}, {
  before: 'Nie wiesz co robić gdy pada deszcz lub masz małą grupę',
  after: 'Masz gotowe treści na każde zajęcia niezależnie od warunków'
}, {
  before: 'Rodzice pytają o wyniki, ale nie masz nic do pokazania',
  after: 'Masz gotowe raporty dla rodziców na każdy miesiąc'
}, {
  before: 'Uczniowie nie rozwijają się systematycznie',
  after: 'Indywidualny system oceny każdego ucznia na każdym poziomie'
}, {
  before: 'Improwizujesz na każdych zajęciach',
  after: 'Otwierasz PDF i zaczynasz — zero stresu'
}];
export function BeforeAfter() {
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-41">
      <div className="max-w-6xl mx-auto" data-id="element-42">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-white mb-8 md:mb-12" data-id="element-43">
          Zmiana, którą poczujesz od pierwszych zajęć
        </h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-44">
          <div className="bg-[#1A3257] rounded-2xl p-5 md:p-8 border border-[#E74C3C]/30 shadow-sm" style={{
          background: 'linear-gradient(to bottom right, #1A3257, rgba(231, 76, 60, 0.05))'
        }} data-id="element-45">
            <h3 className="text-xl md:text-2xl font-display font-bold text-[#E74C3C] mb-6 flex items-center gap-2" data-id="element-46">
              <X className="w-5 h-5 md:w-6 md:h-6" data-id="element-47" />
              PRZED systemem
            </h3>
            <div className="space-y-4" data-id="element-48">
              {comparisons.map((item, index) => <div key={index} className="flex gap-3" data-id="element-49">
                  <X className="w-5 h-5 text-[#E74C3C] flex-shrink-0 mt-0.5" data-id="element-50" />
                  <p className="text-sm md:text-base text-[#E8EAF0]" data-id="element-51">
                    {item.before}
                  </p>
                </div>)}
            </div>
          </div>

          <div className="bg-[#1A3257] rounded-2xl p-5 md:p-8 border border-[#2ECC71]/30 shadow-sm" style={{
          background: 'linear-gradient(to bottom right, #1A3257, rgba(46, 204, 113, 0.05))'
        }} data-id="element-52">
            <h3 className="text-xl md:text-2xl font-display font-bold text-[#2ECC71] mb-6 flex items-center gap-2" data-id="element-53">
              <Check className="w-5 h-5 md:w-6 md:h-6" data-id="element-54" />
              PO systemie
            </h3>
            <div className="space-y-4" data-id="element-55">
              {comparisons.map((item, index) => <div key={index} className="flex gap-3" data-id="element-56">
                  <Check className="w-5 h-5 text-[#2ECC71] flex-shrink-0 mt-0.5" data-id="element-57" />
                  <p className="text-sm md:text-base text-[#E8EAF0]" data-id="element-58">
                    {item.after}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}